import { Tile } from "@carrotfertility/carotene-core"
import React from "react"

export function BookingCard({ children }: { children: React.ReactNode }): JSX.Element {
  return (
    <Tile
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[1],
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(theme.tokens.spacing.lg),
        inlineSize: "100%",
        maxInlineSize: 640,
        boxSizing: "border-box"
      })}
    >
      {children}
    </Tile>
  )
}
